export enum WorkshopSceneState{
  Wait = 'wait',
  Video = 'video',
  Drawing = 'draw'
};